import React from "react";
import {Grid} from "@mui/material";
import {UserName} from "./infoPerson/_userName";
import {StatusPerson} from "./infoPerson/_statusPerson";
import {Password} from "./infoPerson/_password";
import {PasswordConfirm} from "./infoPerson/_passwordConfirm";
import {useParams} from "react-router-dom";

const UserAccount = ({...props}) => {

    const {teacherId} = useParams()

    return (
        <Grid container spacing={2}>
            <Grid xs={6} sm={6} md={6} lg={6} item>
                <UserName/>
            </Grid>
            <Grid xs={6} sm={6} md={6} lg={6} item>
                <StatusPerson/>
            </Grid>
            {!!!teacherId && <Grid xs={6} sm={6} md={6} lg={6} item>
                <Password/>
            </Grid>}
            {!!!teacherId && <Grid xs={6} sm={6} md={6} lg={6} item>
                <PasswordConfirm/>
            </Grid>}
        </Grid>
    )
}
export default UserAccount;